import { useMemo } from 'react';
import { DateTime } from 'luxon';

export const usePostFormatDate = (isoDate, timezone) => {
  return useMemo(() => {
    if (!isoDate) return '';

    const date = DateTime.fromISO(isoDate).setZone(timezone);
    const now = DateTime.now().setZone(timezone);

    if (date.hasSame(now, 'day')) {
      return date.toFormat('h:mm a'); // Today: H:MM AM/PM (no leading zero)
    }

    return date.toFormat('M/dd/yy'); // Not today: M/DD/YY (no leading zero for month)
  }, [isoDate, timezone]);
};
